import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin, Tools, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';
//import {FloatMixin} from '../layout/layout.js';
import Alert from './alert.js';
import Button from './button.js';

import './progress-bus.less';

export const ProgressBus = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin,
    //FloatMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.ProgressBus',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-progress-bus',
      open: 'uu5-bricks-progress-bus-open',
      alert: 'uu5-bricks-progress-bus-alert',
      body: 'uu5-bricks-progress-bus-body',
      message: 'uu5-bricks-progress-bus-message',
      button: 'uu5-bricks-progress-bus-button',
      buttons: 'uu5-bricks-progress-bus-buttons',
      pending: 'uu5-bricks-progress-bus-pending',
      position: 'uu5-bricks-progress-bus-',
      alertPosition: 'uu5-bricks-progress-bus-alert-'
    },
    warnings: {
      itemMissing: 'Item id %s was not in item list.'
    },
    errors: {
      itemMissing: 'Item id %s was not in item list.'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    position: React.PropTypes.oneOf([
      'left',
      'center',
      'right'
    ]),
    verticalPosition: React.PropTypes.oneOf([
      'top',
      'bottom'
    ]),
    alertPosition: React.PropTypes.oneOf([
      'top',
      'bottom'
    ])
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      position: 'center',
      verticalPosition: 'top',
      alertPosition: 'top'
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    return {
      openId: null,
      itemList: {}
    };
  },

  componentWillUnmount() {
    if (this._timeouts) {
      for (let key in this._timeouts) {
        clearTimeout(this._timeouts[key]);
      }
    }
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  addItem(itemProps, setStateCallback){
    let id = Tools.generateUUID();
    this.setState(
      (state) => {
        let itemList = state.itemList;
        itemList[id] = {
          code: itemProps.code || id,
          message: itemProps.message,
          colorSchema: itemProps.colorSchema || 'grey',
          pending: itemProps.pending || false,
          closeDisabled: itemProps.closeDisabled || false,
          timeout: itemProps.timeout,
          onClick: itemProps.onClick,
          onClose: itemProps.onClose
        };

        return {itemList: itemList};
      }, setStateCallback
    );
    return id;
  },

  removeItem(itemId, setStateCallback) {
    this.setState(
      (state) => {
        let result;
        if (state.itemList[itemId]) {
          let list = state.itemList;
          delete list[itemId];
          result = {itemList: list};
        } else {
          this.showWarning('itemMissing', itemId);
        }
        return result;
      }, setStateCallback
    );

    return this;
  },

  getItem(itemId) {
    return this.state.itemList ? this.state.itemList[itemId] : null;
  },

  getItemByCode(code) {
    let item = null;

    let ids = Object.keys(this.state.itemList);
    for (let i = 0; i < ids.length; i++) {
      if (this.state.itemList[ids[i]].code === code) {
        item = this.state.itemList[ids[i]];
        item.id = ids[i];
        break;
      }
    }
    return item;
  },

  getItemsByCode(code) {
    let itemList = [];
    Object.keys(this.state.itemList).forEach((id) => {
      let item = this.state.itemList[id];
      if (item.code === code) {
        itemList.push(Tools.merge({}, item, {id: id}));
      }
    });
    return itemList;
  },

  setItem(itemId, itemProps, setStateCallback) {
    this.setState(
      (state) => {
        let result;
        if (state.itemList[itemId]) {
          let newItemList = state.itemList;
          newItemList[itemId] = itemProps;
          result = {itemList: newItemList};
        } else {
          this.showError('itemMissing', itemId);
        }
        return result;
      }, setStateCallback
    );

    return this;
  },

  updateItem(itemId, itemProps, setStateCallback) {
    this.setState(
      (state) => {
        let result;
        if (state.itemList[itemId]) {
          let newItemList = state.itemList;
          newItemList[itemId] = Tools.merge(newItemList[itemId], itemProps);
          result = {itemList: newItemList};
        } else {
          this.showError('itemMissing', itemId);
        }
        return result;
      }, setStateCallback
    );

    return this;
  },

  getItemList() {
    let itemList = [];
    Object.keys(this.state.itemList).forEach((id) => {
      let item = this.state.itemList[id];
      itemList.push(Tools.merge(item, {id: id}));
    });
    return itemList;
  },

  showAlert(itemId, setStateCallback) {
    if (this.state.itemList[itemId]) {
      this.setState({openId: itemId}, setStateCallback);
    } else {
      this.showError('itemMissing', itemId);
    }
    return this;
  },

  hideAlert(itemId, setStateCallback) {
    if (this.state.itemList[itemId] && this.state.openId === itemId) {
      this.setState({openId: null}, setStateCallback);
    } else {
      this.showError('itemMissing', itemId);
    }
    return this;
  },

  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getAlert() {
    let result;
    let itemProps = this.getItem(this.state.openId);
    let className = this.getClassName().alert + ' ' + this.getClassName().alertPosition + this.props.alertPosition;

    if (itemProps && itemProps.message) {
      result = <Alert
        content={itemProps.message}
        onClose={itemProps.onClose || (() => this.removeItem(this.state.openId))}
        closeDisabled={itemProps.closeDisabled}
        colorSchema={itemProps.colorSchema}
        className={className}
        hidden={false}
        block
      />;
    }

    return result;
  },

  _getItems() {
    this._timeouts = this._timeouts || {};
    return (
      Object.keys(this.state.itemList).map(
        (key) => {
          let itemProps = this.state.itemList[key];
          let onClick = itemProps.message ? itemProps.onClick || (() => this.showAlert(key)) : null;

          if (itemProps.timeout) {
            this._timeouts[key] = this._timeouts[key] || setTimeout(() => this.state.itemList[key] && this.removeItem(key), itemProps.timeout);
          }

          let className = itemProps.pending ? this.getClassName().button + ' ' + this.getClassName().pending : this.getClassName().button;

          return <Button
            onClick={onClick}
            pressed={this.state.openId === key}
            key={key}
            content=" "
            colorSchema={itemProps.colorSchema}
            className={className}
            disabled={!itemProps.message}
          />
        }
      )
    );
  },
  //@@viewOff:componentSpecificHelpers

  // Render
  _getMainAttrs: function () {
    let mainAttrs = this.buildMainAttrs();
    mainAttrs.className += ' ' + this.getClassName().position + this.props.position;
    mainAttrs.className += ' ' + this.getClassName().position + this.props.verticalPosition;
    mainAttrs.className += Object.keys(this.state.itemList).length > 0 ? ' ' + this.getClassName().open : null;
    return mainAttrs;
  },

  //@@viewOn:render
  render: function () {
    let mainAttrs = this._getMainAttrs();

    let result = <div {...mainAttrs} />;

    if (Object.keys(this.state.itemList).length > 0) {
      result = (
        <div {...mainAttrs}>
          {this.props.alertPosition === 'top' && this._getAlert()}

          <div className={this.getClassName().body}>
            <div className={this.getClassName().message}>
              {this.getChildren()}
            </div>
            <div className={this.getClassName().buttons}>
              {this._getItems()}
            </div>
          </div>

          {this.props.alertPosition === 'bottom' && this._getAlert()}
        </div>
      );
    }

    return this.getNestingLevel() ? result : null;
  }
  //@@viewOff:render
});

export default ProgressBus;



// WEBPACK FOOTER //
// ./bricks/progress-bus.js